// // // fetch-interceptor.js

// const originalFetch = window.fetch;

// window.fetch = async (...args) => {
//   try {
//     const response = await originalFetch(...args);

//     // If the server responded with an error status
//     if (!response.ok) {
//       switch (
//         response.status
//         // case 404:
//         //   window.location.href = '/error';
//         //   break;
//         // case 500:
//         //   window.location.href = '/error';
//         //   break;
//         // default:
//         //   window.location.href = '/error';
//       ) {
//       }
//     }

//     return response;
//   } catch (error) {
//     // Handle network errors (like server down, timeout, DNS fail)
//     console.error('Global fetch error:', error);
//     // window.location.href = '/error';
//     throw error;
//   }
// };


// // fetch-interceptor.js

const originalFetch = window.fetch;

window.fetch = async (...args) => {
  try {
    const response = await originalFetch(...args);

    // // If the server responded with an error status
    // if (!response.ok) {
    //   // switch (response.status) {
    //   //   // case 404:
    //   //   //   window.location.href = '/error';
    //   //   //   break;
    //   //   // case 500:
    //   //   //   window.location.href = '/error';
    //   //   //   break;
    //   //   // default:
    //   //   //   window.location.href = '/error';
    //   // }
    // }

    return response;
  } catch (error) {
    // Handle network errors (like server down, timeout, DNS fail)
    console.error('Global fetch error:', error);
    window.location.href = '/error';
    throw error;
  }
};
// fetch-interceptor.js

// const originalFetch = window.fetch;

// window.fetch = async (...args) => {
//   try {
//     const response = await originalFetch(...args);
//     return response; // Never redirect here, even if 404/500
//   } catch (error) {
//     console.error('Global fetch error:', error);

//     // Detect true "backend unreachable" cases
//     // Safari throws TypeError for these, Chrome throws NetworkError/Failed to fetch
//     const isNetworkError =
//       error instanceof TypeError || error.name === 'NetworkError';

//     if (isNetworkError && window.location.pathname !== '/error') {
//       window.location.href = '/error';
//     }

//     throw error;
//   }
// };
